module.exports = __webpack_public_path__ + "static/media/delete.ca8947f4.svg";